/**
 * Normalize category/type values to ensure consistent casing
 * AMC/Amc/amc → AMC
 * Refilling/refilling/REFILLING → Refilling
 */
export const normalizeType = (type: string | null | undefined): string => {
  if (!type) return '';
  
  const normalized = type.trim().toLowerCase();
  
  if (normalized.includes('refilling')) {
    return 'Refilling';
  }
  
  if (normalized.includes('amc')) {
    return 'AMC';
  }
  
  // If no match, return the original with first letter capitalized
  return type.charAt(0).toUpperCase() + type.slice(1);
};

/**
 * Normalize any string field to consistent casing
 * Handles common variations
 */
export const normalizeField = (field: string | null | undefined, type?: 'AMC' | 'Refilling'): string => {
  if (!field) return '';
  
  const normalized = field.trim().toLowerCase();
  
  // Type normalization
  if (type === 'Refilling' && normalized.includes('refilling')) {
    return 'Refilling';
  }
  
  if (type === 'AMC' && normalized.includes('amc')) {
    return 'AMC';
  }
  
  // Default: capitalize first letter
  return field.charAt(0).toUpperCase() + field.slice(1);
};

/**
 * Normalize an object's type field if it exists
 */
export const normalizeRecord = <T extends Record<string, any>>(
  record: T,
  typeFieldName: keyof T = 'type' as keyof T
): T => {
  if (!record) return record;
  
  return {
    ...record,
    [typeFieldName]: normalizeType(record[typeFieldName] as string),
  };
};

/**
 * Normalize an array of records
 */
export const normalizeRecords = <T extends Record<string, any>>(
  records: T[],
  typeFieldName: keyof T = 'type' as keyof T
): T[] => {
  return records.map(record => normalizeRecord(record, typeFieldName));
};
